import {
  CREATESETTLEMENTREPORTPARTNER_SUCCESS,
  CREATESETTLEMENTREPORTPARTNER_FAILED,
  RESET_CREATESETTLEMENTREPORTPARTNER,
  LOADING_CREATESETTLEMENTREPORTPARTNER,
  NETWORK_ERROR_CREATESETTLEMENTREPORTPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetCreateSettlementPartner = () => {
  return { type: RESET_CREATESETTLEMENTREPORTPARTNER };
};

const createSettlementPartnerReport = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_CREATESETTLEMENTREPORTPARTNER });
  await partnerServices
    .post("createSettlement", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(createSettlementPartnerReportSuccess(res.data));
          break;
        default:
          dispatch(createSettlementPartnerReportFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_CREATESETTLEMENTREPORTPARTNER, payload: err });
    });
};
function createSettlementPartnerReportSuccess(data) {
  return {
    type: CREATESETTLEMENTREPORTPARTNER_SUCCESS,
    payload: data,
  };
}
function createSettlementPartnerReportFailed(data) {
  return {
    type: CREATESETTLEMENTREPORTPARTNER_FAILED,
    payload: data,
  };
}

export { resetCreateSettlementPartner, createSettlementPartnerReport };
